import { z } from 'zod';

import { InsuranceType } from '@/models/insurance.ts';

export const schedulerInsuranceInfoSchema = z.object({
    location_id: z.string(),
    insurance_type: z.enum(InsuranceType),
});

export type SchedulerInsuranceInfoSchema = z.infer<typeof schedulerInsuranceInfoSchema>;

export const validUserInsuranceSchema = z.object({
    dc_user_id: z.string(),
    insurances: z.array(schedulerInsuranceInfoSchema),
});

export const validateUserInsuranceResponseSchema = z.object({
    eterno_user_id: z.string().optional(),
    users_insurance_infos: z.array(validUserInsuranceSchema),
    duplication_required: z.boolean(),
    duplication_done: z.boolean(),
});

export type ValidateUserInsuranceResponse = z.infer<typeof validateUserInsuranceResponseSchema>;
